import { ChangeMatrixCommand } from "ags/commands/change-matrix-command";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { RecoverFreespinsState } from "slotworks/state-machine/standard/states/recover-freespins-state";

export class AgsRecoverFreespinsState extends RecoverFreespinsState {

    public complete() {
        Services.get(SoundService).customEvent("start_freespins");
        this.setupMatrixComponent();
        super.complete();
    }

    protected setupMatrixComponent() {
        ChangeMatrixCommand(true);
    }
}
